import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import { createSquareNodeTypeIcon, wrapNodeIconInSvgTag } from '../common';
import { drawSquareBackground } from '../drawIconBackground';

const ICON_SIZE = 40;

// Official Microsoft Azure "Network Interface" service icon, transcribed
// from the Azure Architecture Icons set (November 2025)
// (https://learn.microsoft.com/en-us/azure/architecture/icons/). The
// source artwork is 18×18 — wrapped in `<g transform="translate(2 2)
// scale(2)">` to fit the codebase's 40×40 icon grid with a 2 px padding
// (matches the visual margin used by `azureLb`, `azureVnet`, …). The
// vertical green linear-gradient on the chassis is approximated by the
// dominant colour `#76bb43` so we don't have to inline `<defs>` (no other
// icon in the registry uses gradients, which keeps id-collision risk
// zero when many icons render in the same DOM tree).
function createAzureNicIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const icon = `
    ${drawSquareBackground(ICON_SIZE, opts.style)}
    <g transform="translate(2 2) scale(2)">
      <path d="M15.89,2.91h1.27a.34.34,0,0,1,.34.34v3.5a.34.34,0,0,1-.34.34H15.89a0,0,0,0,1,0,0V2.91A0,0,0,0,1,15.89,2.91Z" fill="#ffca00"/>
      <path d="M15.89,9h1.27a.34.34,0,0,1,.34.34v5.86a.34.34,0,0,1-.34.34H15.89a0,0,0,0,1,0,0V9A0,0,0,0,1,15.89,9Z" fill="#ffca00"/>
      <rect x="2.13" y="1.5" width="13.76" height="15" rx="0.69" fill="#76bb43"/>
      <path d="M5.9,12.9H5.19A.2.2,0,0,1,5,12.69V4.34a.19.19,0,0,1,.19-.2H7.12a.19.19,0,0,1,.19.2.2.2,0,0,1-.19.21H5.38v7.93H5.9a.2.2,0,0,1,.19.21A.21.21,0,0,1,5.9,12.9Z" fill="#b4ec36"/>
      <path d="M6,13.92H4.4a.2.2,0,0,1-.19-.21L4.08,3.38a.2.2,0,0,1,.06-.15.16.16,0,0,1,.13-.06H7.12v.41H4.47l.12,9.92H6Z" fill="#b4ec36"/>
      <path d="M12,13H10.41a.19.19,0,0,1-.14-.07.18.18,0,0,1-.06-.14V7.9a.19.19,0,0,1,.19-.2l.91,0,0-2.25h.38l0,2.44a.2.2,0,0,1-.18.21l-.91,0v4.42H12Z" fill="#b4ec36"/>
      <rect x="7.07" y="2.29" width="6.14" height="3.11" rx="0.26" fill="#365615"/>
      <rect x="5.86" y="12.69" width="4.9" height="1.09" rx="0.26" transform="translate(21.54 4.93) rotate(90)" fill="#365615"/>
      <rect x="3.99" y="12.71" width="4.9" height="1.09" rx="0.26" transform="translate(19.7 6.82) rotate(90)" fill="#365615"/>
      <rect x="9.98" y="12.71" width="4.9" height="1.09" rx="0.26" transform="translate(25.68 0.83) rotate(90)" fill="#f2f2f2"/>
      <ellipse cx="8.11" cy="8.06" rx="1.04" ry="1.12" fill="#f2f2f2"/>
      <path d="M.5,5.7H1.77A.34.34,0,0,1,2.11,6v5.86a.34.34,0,0,1-.34.34H.5a0,0,0,0,1,0,0V5.7A0,0,0,0,1,.5,5.7Z" transform="translate(2.61 17.95) rotate(180)" fill="#3b3b3b"/>
    </g>
  `;

  return wrapNodeIconInSvgTag(icon, ICON_SIZE, ICON_SIZE, 'topLeft', opts);
}

export const azureNicIcon: NodeTypeIcon = createSquareNodeTypeIcon(
  ICON_SIZE,
  createAzureNicIcon,
);
